import {
  CheckTicketStatusClassNames,
  DATE_FORMAT_LONG,
  T,
} from "../../../../../constants";
import { utcToLocal } from "../../../../../helpers";
import { TicketStatus } from "../../../../../enums";
import { JackpotTicket } from "../../../../../models/jackpot";
import { JackpotTypeNames } from "../../../../../constants/jackpot-types";
import TicketResultKeyValue from "../ticket-result-header/ticket-result-key-value";
import TicketState from "../ticket-result-header/ticket-state";

interface TicketResultHeaderProps {
  ticket: JackpotTicket;
}

const TicketResultHeader: React.FC<TicketResultHeaderProps> = ({ ticket }) => {
  return (
    <>
      <TicketState className={CheckTicketStatusClassNames[TicketStatus.Won]}>
        <TicketResultKeyValue
          label={T.DATE}
          value={utcToLocal(ticket.date, DATE_FORMAT_LONG)}
        ></TicketResultKeyValue>
        <TicketResultKeyValue label={T.JACKPOT_ID} value={ticket.jackpotId} />{" "}
        <TicketResultKeyValue
          label={T.JACKPOT_BARCODE}
          value={ticket.barcode}
        />
        <TicketResultKeyValue label={T.GAME_NAME} value={ticket.gameName} />
        <TicketResultKeyValue
          label={T.JACKPOT_TYPE}
          value={JackpotTypeNames[ticket.jackpotType]}
        />
        <TicketResultKeyValue
          label={T.JACKPOT_AMOUNT}
          value={`${ticket.winAmount.toFixed(2)} ${ticket.currencyCode}`}
        />
      </TicketState>
    </>
  );
};

export default TicketResultHeader;
